$(() => {
  const pad = x => String(x).padStart(2, '0');
  const format = d =>
    `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(
      d.getHours()
    )}:${pad(d.getMinutes())}`;

  $(document).on(
    'change',
    '[data-appointment-start-at], [data-appointment-end-at]',
    function () {
      const date = new Date($(this).val());

      if (isNaN(date.getDate())) {
        return false;
      }

      date.setMinutes(Math.floor(date.getMinutes() / 30) * 30);
      $(this).val(format(date));

      if (!$(this).data('appointment-start-at')) {
        return;
      }

      date.setHours(date.getHours() + 1);
      $(this)
        .closest('.nested-fields')
        .find('input[id$=_end_at]')
        .val(format(date));
    }
  );
});
